import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { twJoin } from 'tailwind-merge'
import { cn } from "../lib/utils"
function Modal({isOpen, setIsOpen, children, locked = false, width = "md:max-w-5xl", panelClassName}) {
  return (
    <Dialog open={isOpen} onClose={() => !locked && setIsOpen(false)} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black bg-opacity-50" />
        <div className="fixed inset-0 flex w-screen items-center justify-center md:p-4">
          <DialogPanel className={cn(
            "w-full border bg-white px-8 py-8 md:px-12 md:py-10 h-full max-h-full md:h-auto relative overflow-auto rounded-lg",
            width,
            panelClassName
          )}>
            {!locked ? <button onClick={() => setIsOpen(false)} className="absolute top-4 right-4 z-10">
              <i className="fas fa-times text-3xl text-black"></i>
            </button> : null}
            {children}
          </DialogPanel>
        </div>
      </Dialog>
  )
}

export default Modal